module.exports = [
  { title: 'query', path: 'query' },
  { title: 'all', path: 'all' },
  { title: 'remove', path: 'remove' },
  { title: 'merge', path: 'merge' },
  { title: 'search', path: 'search' },
]
